const TRAINING_PLAN = [
  // ── SEMANA 1: Base (15-18 May) ──
  {
    day: 1,
    date: "Vie 15 May",
    type: "Cardio base",
    activity: "Caminata rápida + trote suave",
    detail: "10 min caminata rápida → 15 min trote suave (ritmo 6:30-7:00/km) → 5 min caminata",
    km: "3-4 km",
    intensity: 1,
    tip: "Enfócate en un ritmo cómodo donde puedas hablar. Tu objetivo de carrera es 3:48-4:48/km, pero hoy solo construimos base.",
  },
  {
    day: 2,
    date: "Sáb 16 May",
    type: "Carrera",
    activity: "Intervalos cortos",
    detail: "5 min calentamiento → 6×(2 min trote a 5:00/km / 1 min caminata) → 5 min enfriamiento",
    km: "4-5 km",
    intensity: 2,
    tip: "Los intervalos entrenan a tu cuerpo a manejar ritmos más rápidos y recuperarse.",
  },
  {
    day: 3,
    date: "Dom 17 May",
    type: "Carrera larga",
    activity: "Carrera larga lenta",
    detail: "10 min calentamiento → 30 min trote suave (6:00-6:30/km) → 5 min caminata",
    km: "5-6 km",
    intensity: 2,
    tip: "Carrera lenta para construir resistencia. No te preocupes por la velocidad hoy.",
  },
  {
    day: 4,
    date: "Lun 18 May",
    type: "Descanso",
    activity: "Descanso activo",
    detail: "Estiramientos suaves 15-20 min o caminata ligera. Hidratación y buena alimentación.",
    km: "—",
    intensity: 0,
    tip: "El descanso es parte del entrenamiento. Tu cuerpo se repara y fortalece.",
  },

  // ── SEMANA 2: Construcción (19-25 May) ──
  {
    day: 5,
    date: "Mar 19 May",
    type: "Carrera",
    activity: "Trote progresivo",
    detail: "5 min calentamiento → 25 min trote (empieza a 5:30/km, termina a 4:30/km) → 5 min enfriamiento",
    km: "5-6 km",
    intensity: 3,
    tip: "Negative splits: termina más rápido de lo que empezaste. Entrena tu cuerpo a no frenar.",
  },
  {
    day: 6,
    date: "Mié 20 May",
    type: "Fuerza",
    activity: "Circuito funcional",
    detail: "4 rondas: 15 sentadillas + 10 zancadas/pierna + 20 elevaciones talón + 45s plancha. Descanso 60s entre rondas.",
    km: "—",
    intensity: 2,
    tip: "Mantén el core activado en todo momento. Técnica sobre velocidad.",
  },
  {
    day: 7,
    date: "Jue 21 May",
    type: "Carrera",
    activity: "Intervalos de ritmo",
    detail: "5 min calentamiento → 5×(3 min a 4:20-4:40/km / 1.5 min trote suave) → 5 min enfriamiento",
    km: "6-7 km",
    intensity: 3,
    tip: "Estos intervalos simulan el ritmo que necesitas para los 10K entre 38-48 min.",
  },
  {
    day: 8,
    date: "Vie 22 May",
    type: "Descanso",
    activity: "Descanso activo",
    detail: "Yoga suave o estiramientos + foam roller. Enfócate en cuádriceps, isquiotibiales y pantorrillas.",
    km: "—",
    intensity: 0,
    tip: "La recuperación activa mejora la circulación y reduce la rigidez muscular.",
  },
  {
    day: 9,
    date: "Sáb 23 May",
    type: "Carrera",
    activity: "Tempo run",
    detail: "5 min calentamiento → 20 min a ritmo de carrera (4:30-5:00/km) → 5 min enfriamiento",
    km: "6 km",
    intensity: 3,
    tip: "Ritmo de carrera sostenido. Deberías poder decir frases cortas pero no conversar.",
  },
  {
    day: 10,
    date: "Dom 24 May",
    type: "Carrera larga",
    activity: "Simulacro de carrera",
    detail: "10 min calentamiento → 40-45 min trote a ritmo cómodo (5:00-5:30/km) → 5 min enfriamiento",
    km: "8-9 km",
    intensity: 4,
    tip: "¡Tu ensayo general! Prueba la ropa y zapatos que usarás el día de la carrera.",
  },
  {
    day: 11,
    date: "Lun 25 May",
    type: "Descanso",
    activity: "Descanso total",
    detail: "Recuperación completa. Hidratación y buena alimentación. Proteínas para reparar músculo.",
    km: "—",
    intensity: 0,
    tip: "Empieza a visualizar tu meta. Mentalmente ya eres un corredor de 10K.",
  },

  // ── SEMANA 3: Afinamiento (26-31 May) ──
  {
    day: 12,
    date: "Mar 26 May",
    type: "Carrera",
    activity: "Trote suave + strides",
    detail: "5 min calentamiento → 15 min trote suave → 4×100m aceleraciones (strides) → 5 min enfriamiento",
    km: "4 km",
    intensity: 2,
    tip: "Semana de descarga. Reduce volumen para llegar fresco. Los strides mantienen la velocidad.",
  },
  {
    day: 13,
    date: "Mié 27 May",
    type: "Fuerza",
    activity: "Activación ligera",
    detail: "2×10 sentadillas, 2×8 zancadas, 2×15 elevaciones talón, 2×30s plancha",
    km: "—",
    intensity: 1,
    tip: "Solo activación muscular, no agotamiento. Mantén tus piernas activas y listas.",
  },
  {
    day: 14,
    date: "Jue 28 May",
    type: "Carrera",
    activity: "Trote corto a ritmo de carrera",
    detail: "5 min calentamiento → 15 min trote a ritmo objetivo (4:20-4:48/km) → 5 min enfriamiento",
    km: "3-4 km",
    intensity: 2,
    tip: "Practica el ritmo al que quieres correr los 10K. Memoriza la sensación en tus piernas.",
  },
  {
    day: 15,
    date: "Vie 29 May",
    type: "Descanso",
    activity: "Descanso activo",
    detail: "Caminata ligera 15 min + estiramientos suaves. Prepara mentalmente tu estrategia de carrera.",
    km: "—",
    intensity: 0,
    tip: "Planifica: los primeros 3 km conservador, km 4-7 a ritmo, km 8-10 da todo.",
  },
  {
    day: 16,
    date: "Sáb 30 May",
    type: "Descanso",
    activity: "Preparación pre-carrera",
    detail: "Prepara tu ropa, zapatos, número de corredor e hidratación. Caminata de 10 min si quieres.",
    km: "—",
    intensity: 0,
    tip: "Duerme temprano. Cena ligera con carbohidratos (pasta, arroz). Nada nuevo el día de la carrera.",
  },
  {
    day: 17,
    date: "Dom 31 May",
    type: "Meta",
    activity: "¡CARRERA 10K! 🏁",
    detail: "Calentamiento 10 min → Corre tus 10 km (objetivo: 38-48 min) → Enfriamiento y estiramientos",
    km: "10 km",
    intensity: 5,
    tip: "¡Lo lograste! Empieza conservador (5:00/km), acelera en la segunda mitad. Ritmo objetivo: 3:48-4:48/km. ¡Disfrútalo!",
  },
];

export default TRAINING_PLAN;
